import { forwardRef, Spinner as ChakraSpinner, SpinnerProps } from '@chakra-ui/react';

export interface ProgressSpinnerProps extends Omit<SpinnerProps, 'size'> {
  size?: SpinnerProps['width'];
}

/**
 * Progresspinner
 */
const Progresspinner = forwardRef<ProgressSpinnerProps, 'div'>((props, ref) => {
  const { size = '24', ...rest } = props;
  return <ChakraSpinner height={size} width={size} {...rest} ref={ref} />;
});

export default Progresspinner;
